module.exports = __webpack_public_path__ + "media/images/azcentral-844601cd89b6057336fb68e8fae499ef.png";